import { SUPPORTED_LOCALES, t } from "../../lib/i18n";
import { useLocale } from "../../lib/useLocale";

import "./layout.css";

export function LanguageSwitcher() {
  const [locale, setLocale] = useLocale();
  return (
    <div className="lang-switcher" role="group" aria-label={t("common.language")}>
      {SUPPORTED_LOCALES.map((code) => (
        <button
          key={code}
          type="button"
          onClick={() => setLocale(code)}
          className={
            code === locale
              ? "lang-switcher__btn lang-switcher__btn--active"
              : "lang-switcher__btn"
          }
          aria-pressed={code === locale}
        >
          {code}
        </button>
      ))}
    </div>
  );
}
